import { createComponent, getRef } from '@front/utils/alpine';
import { withEl } from '@front/utils';

export default createComponent(() => ({

    scrolled: false,

    init ()
    {
        const headerAccount = document.querySelector('.js-header-account-sidebar') as HTMLElement;
        document.documentElement.style.setProperty('--doc-header-height', this.$el.offsetHeight + 'px');

        document.addEventListener("scroll", (event) => {

            if(window.innerWidth <= 640) {
                // permet d'ajouter du contenu sticky en mobile
                if(! document.body.classList.contains('overflow-clip'))
                    document.body.classList.toggle('overflow-clip');
            }

            if(this.scrolled) {
                if(window.pageYOffset <= 1) {
                    this.scrolled = false;
                }
            }

            if(! this.scrolled) {
                if(window.pageYOffset > 1) {
                    withEl('.js-hidden-header', (el) => {
                        if(headerAccount && !headerAccount.classList.contains('translate-x-full'))
                            return;

                        if(! el.classList.contains('hidden'))
                            el.classList.toggle('hidden');
                    });

                    document.documentElement.style.setProperty('--doc-header-height', this.$el.offsetHeight + 'px');
                    const facetWrapper = document.querySelector('.js-facets-wrapper');
                    document.documentElement.style.setProperty('--doc-facets-wrapper-top', this.$el.offsetHeight + 'px');
                    if(facetWrapper) {
                        document.documentElement.style.setProperty('--doc-facets-wrapper-top', (this.$el.offsetHeight + this.$refs.sticky_menu_container.offsetHeight) + 'px');
                    }

                    if(window.innerWidth > 768)
                        if(! this.$refs.sticky_menu_container.classList.contains('shadow'))
                            this.$refs.sticky_menu_container.classList.toggle('shadow');

                } else {

                    withEl('.js-hidden-header', (el) => {
                        if(headerAccount && !headerAccount.classList.contains('translate-x-full'))
                            return;
                        
                        if(el.classList.contains('hidden'))
                            el.classList.toggle('hidden');
                    });

                    document.documentElement.style.setProperty('--doc-header-height', this.$el.offsetHeight + 'px');

                    if(window.innerWidth > 768)
                        if(this.$refs.sticky_menu_container.classList.contains('shadow'))
                            this.$refs.sticky_menu_container.classList.toggle('shadow');
                }
            }

        });
    },
}));
